import { Popover, PopoverContent, PopoverArrow, PopoverBody } from '@chakra-ui/react';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { FlagBadge } from './FlagBadge';
import { HoverPopoverTrigger } from './HoverPopoverTrigger';

export function TimeTakenBadge({
   timeRequired,
   className,
}: {
   timeRequired: string;
   className?: string;
}) {
   return (
      <Popover trigger="hover" strategy="fixed">
         <HoverPopoverTrigger>
            <FlagBadge themeColor="gray" background="gray.100" icon={faClock} className={className}>
               {timeRequired}
            </FlagBadge>
         </HoverPopoverTrigger>
         <PopoverContent>
            <PopoverArrow backgroundColor="gray.800" />
            <PopoverBody borderRadius="md" backgroundColor="gray.800" color="white" fontSize="14px">
               {_js(
                  'Rough estimate of how long this takes. (Use this to plan your day, not to feel judged.)'
               )}
            </PopoverBody>
         </PopoverContent>
      </Popover>
   );
}
